import Image from 'next/image'
import { STATIC_IMAGE_BASE } from '@mc/constants'
import { Trans } from '@mc/i18n'
import { InterstitialStep } from '../../components/InterstitialStep'

export const COMMUTE_IMAGE = `${STATIC_IMAGE_BASE}/onTheGoHIWDisco316.png`

export const OwnPace = () => (
  <InterstitialStep
    title={
      <Trans i18nKey='findMyClasses.ownPace.title' ns='@mc/next'>
        <span className='mc-text-color--primary' />
      </Trans>
    }
  >
    <div className='row no-gutters-vertical justify-content-center'>
      <div className='col-12 col-md-10 col-xl-9'>
        <div className='mc-mb-4'>
          <div className='row'>
            <div className='col-6'>
              <DeviceBox device='mobile' />
            </div>
            <div className='col-6'>
              <DeviceBox device='desktop' />
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <DeviceBox device='tv' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </InterstitialStep>
)

interface DeviceBoxProps {
  device: 'desktop' | 'mobile' | 'tv'
}

export const DeviceBox = ({ device }: DeviceBoxProps) => (
  <div
    className='mc-text--center mc-p-5 mc-corners--md mc-h-100'
    style={{
      backgroundColor: 'var(--mc-color-bg-container-tint-dark)',
    }}
  >
    <div className='d-block d-md-none'>
      <DeviceBoxMobile device={device} />
    </div>
    <div className='d-none d-md-block'>
      <DeviceBoxDesktop device={device} />
    </div>
  </div>
)

const DeviceBoxMobile = ({ device }: DeviceBoxProps) => {
  const img = getDeviceImage({ device, isMobile: true })

  return (
    <>
      <p
        className={`mc-text-small mc-mb-5 ${
          device !== 'tv' ? 'mc-text--2-lines' : ''
        }`}
      >
        <Trans
          i18nKey={`findMyClasses.ownPace.devices.${device}`}
          ns='@mc/next'
        >
          <span className='mc-text--bold' />
        </Trans>
      </p>

      <div className='d-flex align-items-center justify-content-center'>
        <Image
          src={img.src}
          alt={device}
          width={img.width}
          height={img.height}
        />
      </div>
    </>
  )
}

const DeviceBoxDesktop = ({ device }: DeviceBoxProps) => {
  const img = getDeviceImage({ device, isMobile: false })

  return (
    <div className='mc-px-md-9 mc-px-lg-0'>
      <p
        className={`mc-text-large mc-mb-5 ${
          device !== 'tv' ? 'mc-text--2-lines' : ''
        }`}
      >
        <Trans
          i18nKey={`findMyClasses.ownPace.devices.${device}`}
          ns='@mc/next'
        >
          <span className='mc-text--bold' />
        </Trans>
      </p>

      <div className='d-flex align-items-center justify-content-center'>
        <Image
          src={img.src}
          alt={device}
          width={img.width}
          height={img.height}
        />
      </div>
    </div>
  )
}

export const getDeviceImage = ({
  device,
  isMobile = false,
}: {
  device: 'desktop' | 'mobile' | 'tv'
  isMobile: boolean
}) => {
  const height = isMobile ? 84 : 104

  switch (device) {
    case 'mobile':
      return {
        src: `${STATIC_IMAGE_BASE}/mobile_desktop.png`,
        width: isMobile ? 48 : 60,
        height,
      }
    case 'tv':
      return {
        src: `${STATIC_IMAGE_BASE}/tv_desktop.png`,
        width: isMobile ? 121 : 150,
        height,
      }
    default:
      return {
        src: `${STATIC_IMAGE_BASE}/desktop_desktop.png`,
        width: isMobile ? 105 : 140,
        height,
      }
  }
}
